import React, { useState, useEffect } from 'react';
import styles from './Layout.module.css'; // Import CSS styles
import { useKeyboard } from '../../contexts/KeyboardContext';
import { useLayout } from './LayoutContext';

interface LayoutViewProps {
    children: React.ReactNode; // Content of the screen
    containerClassName?: string;
    isHidden?: boolean;
    removeTopPadding?: boolean;
    noPadding?: boolean;
}

const LayoutView: React.FC<LayoutViewProps> = ({ children, isHidden, containerClassName, removeTopPadding, noPadding }) => {
    const { isKeyboardVisible } = useKeyboard();

    useEffect(() => {
    }, [isKeyboardVisible]);

    const { baseZIndex } = useLayout();

    return (
        <>
            <div
                className={
                    `layoutView
                    ${styles.screenView}
                    ${isKeyboardVisible ? styles.keyboardVisible : ''}
                    ${isHidden ? styles.hidden : ""}
                    ${containerClassName ?? ''}
                    ${removeTopPadding ? styles.noTopPadding : ''}
                    ${noPadding ? styles.noPadding : ''}
                    `}
                style={{ zIndex: baseZIndex }}
            >
                {children}
            </div>
        </>
    );
};

export default LayoutView;
